export const SERVICES_LIST = [{
  header: 'Парные занятия',
  description: 'Работа в&nbsp;паре &mdash;&nbsp;максимум спикинга',
  prices: {
    basic: 12000,
    twoMonths: 10800,
    prev: {
      twoMonths: 12000
    }
  },
  benefitsList: ['Симуляция рабочей коммуникации (переговоры, презентации, встречи)', 'Нетворкинг', 'Необходимая для работы грамматика и&nbsp;лексика', 'Case studies (практические разборы реальных кейсов на&nbsp;английском)'],
  link: '/pair-lessons',
  isServicePrimary: false,
  isExternalLink: false
}, {
  header: 'Индивидуальные занятия',
  description: 'Для тех, кто нацелен на&nbsp;быстрый результат',
  prices: {
    basic: 17600,
    twoMonths: 16000,
    prev: {
      twoMonths: 17600
    }
  },
  benefitsList: ['Гибкий график', 'Личный учебный план для достижения целей', 'Занятия с&nbsp;русскоязычным преподавателем или с&nbsp;носителем', 'Подготовка к&nbsp;экзамену или собеседованию'],
  link: '/individual-lessons',
  isServicePrimary: true,
  isExternalLink: false
}, {
  header: 'Корпоративные занятия',
  description: 'Составляем курсы для команд&nbsp;&mdash; индивидуально и&nbsp;в&nbsp;группе',
  benefitsList: ['Симуляция рабочей коммуникации (переговоры, презентации, встречи)', 'Нацеленность на&nbsp;результат каждого вашего сотрудника', 'Персональная обратная связь и&nbsp;тестирование прогресса', 'Case studies (практические разборы реальных кейсов на&nbsp;английском)'],
  link: '/for-companies',
  isServicePrimary: false,
  isExternalLink: false
}];
export type ServiceItem = (typeof SERVICES_LIST)[number];